import { createSelector } from 'reselect';
import {
    transformTags,
    transformActivity,
    transformSelectDate,
    transformContributors,
} from './transformers';
import { numberWithCommas } from '../../common/utils';

export const getTopContributorsState = (state) =>
    state.dashboard.topContributors || [];

export const getContributorsLoadingState = (state) =>
    state.dashboard.contributorsLoading || false;

export const getTopTagsState = (state) =>
    state.dashboard.topTags || { mlTags: [], userTags: [] };

export const getTagsLoadingState = (state) =>
    state.dashboard.tagsLoading || false;

export const getTotalTagsState = (state) => state.dashboard.totalTags || 0;

export const getActivityState = (state) => state.dashboard.activityData || [];

export const getActivityLoadingState = (state) =>
    state.dashboard.activityLoading || false;

export const getLitterCountState = (state) => state.dashboard.litterCount || 0;

export const getPiecesCollectedLoadingState = (state) =>
    state.dashboard.piecesLoading || false;

export const getTaxonomyState = (state) => state.dashboard.taxonomy || '';

export const getSelectDateState = (state) => state.dashboard.date || '';

export const getCustomDateState = (state) => state.dashboard.customDate || {};

export const getSelectYearState = (state) => state.dashboard.year || '';

export const getTopContributors = createSelector(
    getTopContributorsState,
    (topContributors) => transformContributors(topContributors),
);

export const getContributorsLoading = createSelector(
    getContributorsLoadingState,
    (loading) => loading,
);

export const getTopTags = createSelector(getTopTagsState, (topTags) =>
    transformTags(topTags.userTags, 'orange'),
);

export const getMlTags = createSelector(getTopTagsState, (topTags) =>
    transformTags(topTags.mlTags, 'blue'),
);

export const getTagsLoading = createSelector(
    getTagsLoadingState,
    (loading) => loading,
);

export const getTotalTags = createSelector(getTotalTagsState, (totalTags) =>
    numberWithCommas(totalTags),
);

export const getActivityData = createSelector(
    getActivityState,
    (activityData) => transformActivity(activityData),
);

export const getActivityLoading = createSelector(
    getActivityLoadingState,
    (loading) => loading,
);

export const getUserLitterCount = createSelector(
    getLitterCountState,
    (litterCount) => litterCount,
);

export const getPiecesCollectedLoading = createSelector(
    getPiecesCollectedLoadingState,
    (loading) => loading,
);

export const getTaxonomy = createSelector(
    getTaxonomyState,
    (taxonomy) => taxonomy,
);

export const getDate = createSelector(getTaxonomyState, (taxonomy) => taxonomy);

export const getSelectDate = createSelector(
    getSelectDateState,
    getCustomDateState,
    (date, customDate) => transformSelectDate(date, customDate),
);

export const getSelectYear = createSelector(getSelectYearState, (year) => year);

export const getTotalMlTags = (state) => state.dashboard.totalMlTags || '';

export const getTotalDistilledTags = (state) =>
    state.dashboard.totalDistilledTags || '';
